import { createSlice } from "@reduxjs/toolkit";
import { ThunkHttpClient } from "../../utils/httpThunkClient";

export const saveOrUpdateSupplierData = ThunkHttpClient.post('master/saveOrUpdateSupplierData', (body) => ({url:'master/saveOrUpdateSupplierData', body}))
export const updateSupplierStatus = ThunkHttpClient.put('master/updateSupplierStatus', (body) => ({url:`master/updateSupplierStatus/${body.id}?isActive=${body.active}`, body}))
export const getAllSuppliers = ThunkHttpClient.get('master/getAllSupplierData', (status) => `master/fetchAllActiveSupplierData?status=${status}`);
export const fetchAllBankName = ThunkHttpClient.get('master/fetchAllBankName', () => `master/fetchAllBankName`);

const initialState = {
    supplierData: [],
    bankName: [],
    loading: false
}

export const supplierDataSlice = createSlice({
    name: 'supplierData',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(saveOrUpdateSupplierData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(saveOrUpdateSupplierData.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(saveOrUpdateSupplierData.rejected, (state, action) => {
            state.loading = false;
        });

        // Get All Suppliers
        builder.addCase(getAllSuppliers.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAllSuppliers.fulfilled, (state, action) => {
            state.loading = false;
            state.supplierData = action.payload.data;
        });
        builder.addCase(getAllSuppliers.rejected, (state, action) => {
            state.loading = false;
        });

        // Get All Bank Name
        builder.addCase(fetchAllBankName.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAllBankName.fulfilled, (state, action) => {
            state.loading = false;
            state.bankName = action.payload.data;
        });
        builder.addCase(fetchAllBankName.rejected, (state, action) => {
            state.loading = false;
        });
    },
});

export default supplierDataSlice.reducer;
